import _ from "lodash";
import { connect } from "react-redux";
import { Form } from "formik";
import moment from "moment";
import React, { Component } from "react";
import Select from "react-select";

import { api } from "@/APIRequests";
import Button from "@/components/UI/Button";
import CalendarPreferences from "@/components/Provider/CalendarPreferences/CalendarPreferences";
import {
  CARE_MANAGER_VALIDATION_SCHEMA,
  VALIDATION_SCHEMA,
} from "@/containers/Dashboard/Providers/schema/providerProfileBasicValidation";
import { CustomForm } from "@/component-library/CustomForm";
import FormikInput from "@/components/UI/FormikInput";
import FormikMobileInput from "@/components/UI/formikMobileInput";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import {
  getProviderProfile,
  getUsernameFromToken,
  isAuthorized,
  isUserAdmin,
  isUserPCP,
  updateProviderProfile,
} from "@/redux/actions/auth";
import images from "@/utils/images";
import Input from "@/components/UI/Input";
import ProfileLoader from "@/components/Common/Loaders/ProfileLoader";
import { PROVIDER_BASIC_SCHEMA } from "@/containers/Dashboard/Providers/schema/providerProfileBasicSchema";
import { provider_case_manager, provider_peer, providerRoute } from "@/config/roles";
import { ProviderEnum } from "@/core/constants/provider";
import ProviderUniversalAccessManagementCard from "@/components/Admin/Provider/ProviderUniversalAccessManagementCard";
import { setDynamicRouteConfiguration } from "@/redux/actions/navbar";

import "./styles.scss";
import SubmitControls from "../../Patient/Profile/SubmitControls";

import AcceptedAgeRange from "./AcceptedAgeRange";
import ProfileDetailsCard from "./ProfileDetailsCard";
import StatesToPractice from "./StatesToPractice";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acceptedAgeRanges: [],
      acceptNewPatients: true,
      editBasic: false,
      hasScrolledOnLoad: false,
      isOnBehalfOf: getUsernameFromToken() !== this.props.match.params.providerId,
      profileData: null,
      providerAvatar: null,
      providerId: this.props.match.params.providerId ? this.props.match.params.providerId : null,
      showInsurancePopUp: false,
      stateModal: null,
      updatedInsurance: [],
      validationSchema: isUserPCP() ? CARE_MANAGER_VALIDATION_SCHEMA : VALIDATION_SCHEMA,
    };
  }

  toggleStateModal = () => {
    this.setState({ stateModal: !this.state.stateModal });
  };

  iterableBasicInfo = () => [
    { title: "Full Name", value: this.state.profileData.name || "" },
    { title: "Provider Type", value: this.state.profileData.provider_type },
    { title: "Email", value: this.state.profileData.email || "" },
    { title: "Mobile", value: this.state.profileData.mobile || "" },
    {
      title: "CP Credential",
      value: this.state.profileData.cp_credentials || "",
    },
    { title: "NPI Number", value: this.state.profileData.npi_number || "" },
    { title: "Practice", value: this.state.profileData.practice || "" },
  ];

  componentWillUnmount() {
    this.props.setDynamicRouteConfiguration();
  }

  getProviderAvatar = async () => {
    //         try {
    // api.provider.fetch_
    //         }
    //         catch (err) {
    //         }
  };

  componentDidUpdate() {
    const hash = window.location.hash;

    if (hash && !this.state.hasScrolledOnLoad) {
      const element = document.querySelector(hash);

      if (element) {
        window.scrollTo({
          behavior: "smooth",
          // Offset the header height
          top: element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 85,
        });
        this.setState({ hasScrolledOnLoad: true });
      }
    }
  }

  componentDidMount() {
    const dynamicRouteConfig = {};

    dynamicRouteConfig["logoSection"] = { title: "My Profile" };
    this.props.setDynamicRouteConfiguration(dynamicRouteConfig);
    /** Fetch provider's profile  */
    getProfile(this, this.state.providerId).then(() => {
      const options = { params: { showLoader: false } };

      // TODO: Consider migrating to useInsuranceList hook when refactoring to functional component
      // See MemberProfileMedical.js for reference implementation
      api.patient
        .fetch_insurance_list({ options })
        .then((cleanResponse) => {
          let insuranceList = cleanResponse.carriers.map((carriers) => {
            return { label: carriers, value: carriers };
          });

          this.state.profileData.accepted_insurance.forEach((ai) => {
            if (!cleanResponse.carriers.includes(ai)) {
              insuranceList.push({ label: ai, value: ai });
            }
          });
          let acceptedInsuranceList = this.state.profileData.accepted_insurance.map((ai) =>
            insuranceList.find((ins) => ins.value === ai),
          );

          this.setState({
            acceptedInsuranceList: acceptedInsuranceList,
            insuranceList: insuranceList,
            tempAcceptedInsuranceList: acceptedInsuranceList,
          });
        })
        .catch((err) => {
          // TODO: how do we emit metrics and alarms on client side errors?
          console.log(err);
        });
      /** Fetch provider's avatar  */
      this.getProviderAvatar();
    });
  }

  formatMobileNumber = (val) => {
    let firstNumber = val.substring(0, 3);
    let middleNumber = val.substring(3, 6);
    let lastNumber = val.substring(6, 10);
    let formattedMobileNumber = `(${firstNumber}) ${middleNumber}-${lastNumber}`;

    return formattedMobileNumber;
  };

  /**
   * Below function returns the rendered details which can be reused.
   * @param {string} title - title of the value
   * @param {string} value - value to go below title
   */
  renderTitleWithValue = function (title, value) {
    return (
      <div className="mb-4">
        <div className="fs-14 mb-2 tw:font-bold">
          <span>{title}</span>
        </div>
        <div className="fs-14">
          <span {...getAutomationDataAttr(`ProviderBasicInfo${title.replaceAll(" ", "")}`)}>
            {title == "Mobile" ? this.formatMobileNumber(value) : value}
          </span>
        </div>
      </div>
    );
  };

  shortDetails = () => (
    <div className="ProviderProfile__short-details">
      <div className="py-4 py-lg-0 d-flex flex-row flex-lg-column align-items-center justify-content-lg-center">
        <div className="ProviderProfile__avatar-wpr position-relative mx-3 mx-lg-0 mt-lg-5 mb-lg-4">
          <img
            alt="provider avatar"
            className="mx-auto d-block"
            src={this.props.avatar || images("./common/avatar.png")}
          />
        </div>
        <div className="text-lg-center text-white">
          <div className="fs-16 fs-lg-18 mb-lg-2 tw:font-bold">{this.state.profileData.name}</div>
          <div className="fs-14">{this.state.profileData.provider_type}</div>
        </div>
      </div>
    </div>
  );

  toggleEditBasicInfo = () => {
    this.setState((ps) => {
      return {
        editBasic: !ps.editBasic,
      };
    });
  };

  handleOnBehalfOfRequest = async (data) => {
    if (this.state.isOnBehalfOf) {
      api.provider.update_profile({
        data,
        queryParams: { providerId: this.state.providerId },
      });
    } else {
      this.props.updateProviderProfile(data, this.state.providerId);
    }
  };

  renderFormElement = (formEl, formikProps) => {
    if (formEl.name == "provider_type" || formEl.name === "email" || formEl.name === "practice") {
      return (
        <FormikInput
          disabled
          errors={formikProps.errors}
          formEl={formEl}
          inputBorderDisabled="border-0 px-0"
          testId={`ProviderBasicInfoFormField_${formEl.name}`}
          touched={formikProps.touched}
        />
      );
    } else if (formEl.name == "mobile") {
      return (
        <FormikMobileInput
          errors={formikProps.errors}
          formEl={formEl}
          onChange={async (val) => {
            await formikProps.setFieldValue("mobile", val.value);
            formikProps.setFieldTouched("mobile");
          }}
          testId={`ProviderBasicInfoFormField_${formEl.name}`}
          touched={formikProps.touched}
          value={formikProps && formikProps.values.mobile}
        />
      );
    } else if (isUserAdmin()) {
      return (
        <FormikInput
          errors={formikProps.errors}
          formEl={formEl}
          testId={`ProviderBasicInfoFormField_${formEl.name}`}
          touched={formikProps.touched}
        />
      );
    }

    return (
      <FormikInput
        disabled
        errors={formikProps.errors}
        formEl={formEl}
        inputBorderDisabled="border-0 px-0"
        testId={`ProviderBasicInfoFormField_${formEl.name}`}
        touched={formikProps.touched}
      />
    );
  };

  renderForm = (formikProps) => {
    return (
      <Form>
        <div className="mx-auto px-0">
          <div className="container px-0">
            <div className="row">
              {PROVIDER_BASIC_SCHEMA.map((formEl) => {
                return (
                  <div className="col-12 col-lg-6" key={formEl.name}>
                    {this.renderFormElement(formEl, formikProps)}
                  </div>
                );
              })}
            </div>
            {!isUserAdmin() && (
              <div>
                <div>
                  <p className="ProviderProfile__toUpdateMessage">
                    To update read-only fields, contact{" "}
                    <a href="mailto:support@aptihealth.com">support@aptihealth.com</a>.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
        <SubmitControls cancelHandler={this.toggleEditBasicInfo} testId="ProviderBasicInfoForm" />
      </Form>
    );
  };

  submitHandler = (formData, actions) => {
    actions.setSubmitting(false);
    let data = { ...formData };

    const userData = {
      mobile: data["mobile"],
      ...(isUserAdmin() && {
        cp_credentials: data["cp_credentials"],
        name: data["name"],
        npi_number: data["npi_number"],
      }),
    };

    this.handleOnBehalfOfRequest(userData);

    this.setState({ profileData: data });
    this.toggleEditBasicInfo();
  };

  basicInfo = () => (
    <ProfileDetailsCard
      edit={this.state.editBasic}
      heading="Basic Information"
      isEditable
      onclick={this.toggleEditBasicInfo}
      testId="ProviderProfileBasicInfo"
    >
      <div className="ProviderProfile__basic-info row no-gutters my-2 pt-4 px-2">
        {!this.state.editBasic &&
          this.iterableBasicInfo().map((item, index) => {
            return (
              <div className="col-12 col-lg-6" key={item.title || index}>
                {this.renderTitleWithValue(item.title, item.value)}
              </div>
            );
          })}

        {this.state.editBasic && (
          <CustomForm
            initialValues={this.state.profileData}
            onSubmit={this.submitHandler}
            render={this.renderForm}
            validationSchema={this.state.validationSchema}
          />
        )}
      </div>
    </ProfileDetailsCard>
  );

  acceptNewPatientsChangeHandler = () => {
    let data = { ...this.state.profileData };

    data["accept_new_patients"] = !this.state.acceptNewPatients;

    this.handleOnBehalfOfRequest({ accept_new_patients: data["accept_new_patients"] });
    this.setState({
      acceptNewPatients: !this.state.acceptNewPatients,
      profileData: data,
    });
  };

  acceptNewPatients = () => (
    <div className="ProviderProfile__ProfileDetailsCard p-4 mb-3 mb-lg-4" data-public="true">
      <div className="d-flex justify-content-between">
        <h1 className="fs-16 ml-2 mb-3 pb-1 tw:font-bold">Check the box to accept new patients</h1>
        {/* to remove icon add props -> checkedIcon={false} uncheckedIcon={false} */}

        <Input
          checked={this.state.acceptNewPatients}
          className="AddPatientInput mr-2 form-check-input"
          disabled={isAuthorized(provider_case_manager) || isAuthorized(provider_peer)}
          name="accept_new_patients"
          type="checkbox"
          {...getAutomationDataAttr("ProviderAcceptNewPatientsCheckbox")}
          onChange={this.acceptNewPatientsChangeHandler}
        />
      </div>
    </div>
  );

  showInsPopUp = () => {
    this.setState((ps) => {
      return {
        showInsurancePopUp: !ps.showInsurancePopUp,
      };
    });
  };

  confirmInsuranceUpdate = () => {
    let data = { ...this.state.profileData };

    data.accepted_insurance = [...this.state.tempAcceptedInsuranceList].map((i) => i.value);
    this.handleOnBehalfOfRequest({ accepted_insurance: data.accepted_insurance });
    this.showInsPopUp();
    this.setState({
      acceptedInsuranceList: [...this.state.tempAcceptedInsuranceList],
      profileData: data,
    });
  };

  handleInputChange = (selection, action) => {
    if (action) {
      let updatedInsurance;

      switch (action.action) {
        case "clear": {
          updatedInsurance = [];
          break;
        }

        case "remove-value": {
          updatedInsurance = [...this.state.tempAcceptedInsuranceList].filter(
            (val) => val.value !== action.removedValue.value,
          );
          break;
        }

        case "select-option": {
          updatedInsurance = [...this.state.tempAcceptedInsuranceList];
          updatedInsurance.push(action.option);
          break;
        }

        default:
      }

      this.setState({
        tempAcceptedInsuranceList: updatedInsurance,
      });
    }
  };

  commitAndSubmitStateLicensureDataToServer = (updatedStatesToPractice) => {
    const newProfileData = { ...this.state.profileData };

    // Remove View level concerns from data level concerns
    newProfileData.states_to_practice = updatedStatesToPractice.map(
      ({ expirationDate, licenseNumber, state }) => ({
        expirationDate,
        licenseNumber,
        state,
      }),
    );

    this.setState({ profileData: newProfileData });

    this.handleOnBehalfOfRequest({ states_to_practice: newProfileData.states_to_practice });

    this.toggleStateModal();
  };

  shouldAcceptedInsuranceBeDisabled = () => {
    return ["CASE_MANAGER", "PEER"].includes(this.state.profileData.provider_type);
  };

  insuranceInfo = () => (
    <>
      {isUserAdmin() ? (
        <ProfileDetailsCard
          edit={this.shouldAcceptedInsuranceBeDisabled()}
          heading="Accepted Insurance"
          onclick={this.showInsPopUp}
          testId="AcceptedInsurance"
        >
          <div className="ProviderProfile__insurance-info my-2 pt-4 px-2" data-public="true">
            <div>
              <ul
                className="ProviderProfile__insurance-info-list fs-14"
                {...getAutomationDataAttr("AcceptedInsuranceList")}
              >
                {this.state.profileData &&
                  this.state.profileData.accepted_insurance.sort().map((ins) => {
                    return <li key={ins}>{ins}</li>;
                  })}
              </ul>
            </div>
          </div>
        </ProfileDetailsCard>
      ) : (
        <ProfileDetailsCard
          edit
          heading="Accepted Insurance"
          onclick={this.showInsPopUp}
          testId="AcceptedInsurance"
        >
          <div className="ProviderProfile__insurance-info my-2 pt-4 px-2" data-public="true">
            <div>
              <ul className="ProviderProfile__insurance-info-list fs-14">
                {this.state.profileData &&
                  this.state.profileData.accepted_insurance.sort().map((ins) => {
                    return <li key={ins}>{ins}</li>;
                  })}
              </ul>
            </div>
          </div>

          <p className="ProviderProfile__toUpdateMessage">
            To update accepted insurance, contact{" "}
            <a href="mailto:support@aptihealth.com">support@aptihealth.com</a>.
          </p>
        </ProfileDetailsCard>
      )}
    </>
  );

  renderEachWorkingHourDetail = function (weekDay) {
    let localeTime =
      this.state.profileData.availability[weekDay] &&
      this.state.profileData.availability[weekDay].slots.map((MilitaryhrsArr) => {
        return MilitaryhrsArr.map((Militaryhrs) => {
          return moment(Militaryhrs, "HH:mm").format("hh:mm a");
        });
      });

    return (
      <div className="mb-4" {...getAutomationDataAttr(`WorkingHours${weekDay}`)}>
        <div className="fs-14 mb-2 tw:font-bold">
          <span>{weekDay}</span>
        </div>
        <div className="fs-14 d-flex">
          {this.state.profileData.availability[weekDay] &&
            localeTime.map((hrs, index) => {
              return (
                <span className="w-50" key={index}>
                  {hrs.join(" to ")}
                </span>
              );
            })}

          {this.state.profileData.availability[weekDay] != undefined
            ? this.state.profileData.availability[weekDay].slots.length < 1 && "No Slots Defined"
            : "No Slots Defined"}
        </div>
      </div>
    );
  };

  editWorkingHours = () => {
    let url = providerRoute + "/profile/hours";

    url = this.state.providerId ? `${url}/${this.state.providerId}` : url;
    this.props.history.push(url);
  };

  workingHours = () => (
    <ProfileDetailsCard
      // This is confusing but the edit prop being true means that the edit option is hidden 😵‍💫
      edit={isAuthorized(provider_case_manager) || isAuthorized(provider_peer)}
      heading="Working Hours"
      onclick={this.editWorkingHours}
      testId="WorkingHours"
    >
      <div className="ProviderProfile__working-hours my-2 pt-4 px-2" data-public="true">
        {this.state.profileData.availability && (
          <div>
            {this.renderEachWorkingHourDetail("Monday")}
            {this.renderEachWorkingHourDetail("Tuesday")}
            {this.renderEachWorkingHourDetail("Wednesday")}
            {this.renderEachWorkingHourDetail("Thursday")}
            {this.renderEachWorkingHourDetail("Friday")}
            {this.renderEachWorkingHourDetail("Saturday")}
            {this.renderEachWorkingHourDetail("Sunday")}
          </div>
        )}
        {!this.state.profileData.availability && "No Working Hours Defined"}
      </div>
    </ProfileDetailsCard>
  );

  safeGetStatesOfPractice = () => {
    if (_.isNil(this.state.profileData)) {
      return [];
    } else if (
      _.isNil(this.state.profileData.states_to_practice) ||
      _.isEmpty(this.state.profileData.states_to_practice)
    ) {
      return [];
    }

    return this.state.profileData.states_to_practice;
  };

  setAcceptedAgeRangesV2 = (ageRanges) => {
    const data = { accepted_age_range: ageRanges };

    api.provider.update_profile({
      data,
      queryParams: { providerId: this.state.providerId },
    });
    const profileData = this.state.profileData;

    profileData["accepted_age_range"] = ageRanges;
    this.setState({
      acceptedAgeRanges: ageRanges,
      profileData: profileData,
    });
  };

  shouldDisplayCalendarPreferences = () => {
    const { profileData } = this.state;

    if (!profileData?.provider_type) {
      return false;
    }

    return ![ProviderEnum.CARE_MANAGER, ProviderEnum.PCP].includes(profileData.provider_type);
  };

  updateProviderPreferences = async (newPreferences) => {
    try {
      const data = { preferences: newPreferences };
      const options = { params: { showLoader: true } };
      const { providerId } = this.props.match.params;

      await api.provider.update_profile({
        data: data,
        options,
        queryParams: { providerId },
      });
      this.props.getProviderProfile(providerId);
    } catch (err) {
      console.error("Failed to update preferences:", err);
    }
  };

  render() {
    const updateStatesToPracticeProps = {
      commitAndSubmitStateLicensureDataToServer: this.commitAndSubmitStateLicensureDataToServer,
      dateContext: this.state.dateContext,
      isEditable: true,
      showUpdateStateModal: this.state.stateModal,
      states_to_practice: this.safeGetStatesOfPractice(),
      toggleStateModal: this.toggleStateModal,
    };

    return (
      <div>
        {this.state.showInsurancePopUp && (
          <div
            className="insurancePopUp position-fixed d-flex align-items-center tw:justify-center"
            data-public="true"
          >
            <div className="insurancePopUp__inner d-flex flex-column text-center position-absolute">
              <h2 className="fs-17 mt-4 tw:font-bold">Accepted Insurance</h2>
              <span className="fs-15 mt-2">Accepted Insurance Types</span>

              <div style={{ margin: "0 auto", width: "80%" }}>
                {this.state.insuranceList && (
                  <Select
                    className="basic-multi-select"
                    classNamePrefix="select"
                    closeMenuOnSelect={true}
                    defaultValue={this.state.acceptedInsuranceList}
                    isMulti
                    options={this.state.insuranceList}
                    {...getAutomationDataAttr("AcceptedInsuranceSelect", "id")}
                    onChange={this.handleInputChange}
                  />
                )}
              </div>

              <div className="insurancePopUp__btn-wpr d-flex pt-3 my-4 tw:justify-center">
                <Button
                  className="Btn Btn--otl-pri Btn-sm mx-2"
                  onClick={this.showInsPopUp}
                  type="button"
                >
                  Cancel
                </Button>

                <Button
                  className="Btn Btn--pri Btn-sm mx-2"
                  onClick={this.confirmInsuranceUpdate}
                  type="button"
                  {...getAutomationDataAttr("UpdateAcceptedInsurance")}
                >
                  Update
                </Button>
              </div>
            </div>
          </div>
        )}

        <div className="container px-3">
          <h1 className="d-none d-lg-block fs-22 my-4 py-2 tw:font-bold">My Profile</h1>
          {this.state.profileData ? (
            <div className="ProviderProfile" data-public="true">
              <div className="row no-gutters">
                <div className="col-12 col-lg-3 mt-3 mt-lg-0 mb-3 mb-lg-0">
                  {this.shortDetails()}
                </div>

                <div className="col-12 col-lg-9 px-lg-4">
                  {(this.state.profileData.provider_type.startsWith("BEHAVIORAL") ||
                    this.state.profileData.provider_type === "PRESCRIBE" ||
                    isAuthorized(provider_case_manager) ||
                    isAuthorized(provider_peer)) &&
                    this.acceptNewPatients()}
                  <ProviderUniversalAccessManagementCard providerDetails={this.state.profileData} />

                  {this.basicInfo()}

                  <StatesToPractice {...updateStatesToPracticeProps} />

                  {(this.state.profileData.provider_type.startsWith("BEHAVIORAL") ||
                    this.state.profileData.provider_type === "PRESCRIBE" ||
                    isAuthorized(provider_case_manager) ||
                    isAuthorized(provider_peer)) && (
                    <AcceptedAgeRange
                      acceptedAgeRanges={this.state.acceptedAgeRanges}
                      setAcceptedAgeRanges={this.setAcceptedAgeRangesV2}
                    />
                  )}

                  {this.insuranceInfo()}

                  <div id="scroll-to-preferences"></div>

                  {this.shouldDisplayCalendarPreferences() && (
                    <CalendarPreferences
                      preferences={this.state.profileData?.preferences}
                      updateProfileApiFunction={this.updateProviderPreferences}
                    />
                  )}

                  {this.workingHours()}
                </div>
              </div>
            </div>
          ) : (
            <ProfileLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    flags: state?.flags,
  };
};

export default connect(mapStateToProps, {
  getProviderProfile,
  setDynamicRouteConfiguration,
  updateProviderProfile,
})(Profile);

export const getProfile = async (that, providerId) => {
  try {
    const options = { params: { showLoader: false } };
    const queryParams = { providerId: providerId };
    let response = await api.provider.fetch_provider_profile({
      options,
      queryParams,
    });
    let profileData = response && response.user;

    if (!Object.hasOwn(profileData, "availability")) {
      profileData["availability"] = {};
    }
    that.setState({
      acceptedAgeRanges: _.cloneDeep(_.get(profileData, "accepted_age_range", [])),
      acceptNewPatients: profileData.accept_new_patients,
      profileData: profileData,
    });
  } catch (err) {
    console.log(err);
  }
};
